<!--
 * @Author: chen cs
 * @Date: 2020-02-19 14:52:50
 * @LastEditors: chen cs
 * @LastEditTime: 2020-02-22 22:12:00
 * @Description: file content
 -->
<!--
 * @Author: chen cs
 * @Date: 2020-02-14 17:24:06
 * @LastEditors: chen cs
 * @LastEditTime: 2020-02-20 09:56:12
 * @Description: 分享文件操作页面
 -->
<template>
  <div class="share-main content-box">
    <w-button type="minor" @click="goBack" class="share-button back-button">
      <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 15.8 15.9" style="enable-background:new 0 0 15.8 15.9;" xml:space="preserve">
        <g id="左" transform="translate(10.000000, 7.000000)">
          <path class="st0" style="fill:#7DB500;" d="M-9.6,0.1c-0.5,0.5-0.5,1.4,0,1.9L-3,8.5C-2.5,9-1.6,9-1.1,8.5s0.5-1.4,0-1.9l-4.4-4.3h10
            c0.7,0,1.3-0.6,1.3-1.3S5.3-0.3,4.5-0.3h-10l4.4-4.4C-0.8-5-0.7-5.3-0.7-5.6c0-0.3-0.1-0.7-0.4-1c-0.5-0.5-1.4-0.5-1.9,0L-9.6,0.1z
            "/>
        </g>
      </svg>
      返回平台
    </w-button>
    <div class="share-box">
      <template v-if="state==0">
        <img class="block" src="../../assets/images/share.png" alt="">
        <p class="share-title">{{fileName}}</p>
      </template>
      <template v-if="state==1">
        <img class="block" src="../../assets/images/share-outdate.png" alt="">
        <p class="share-title">分享工程已被删除</p>
      </template>
      <template v-if="state==2">
        <img class="block" src="../../assets/images/share-outtime.png" alt="">
        <p class="share-title">分享工程已失效</p>
      </template>
      <div class="share-buttons" v-if="state==2">
          <w-button type="minor" v-for="(item, i) in buttons" :key="i" class="share-button btn-disable">
            <i :class="[item.icon, 'share-icon']" style="color:#ccc;" v-if="i!==0"></i>
            <i v-else class="define-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="图层_1" x="0px" y="0px" viewBox="0 0 1024 1024" xml:space="preserve" width="18" height="18">
                <title>未标题-1</title>
                <g class="st4">
                  <path class="st5" style="transform: scale(40);transform: translate(-330px, -240px) scale(45);" :style="{fill: '#ccc'}" d="M18,11v2h2h5v9H12V11H18 M20,9H10v15h17V11h-7V9L20,9z"/>
                </g>
              </svg>
            </i><span>{{item.name}}</span>
          </w-button>
        </div>
      <div class="share-buttons" v-if="state==0">
        <template v-if="user.userType!=1">
          <w-button type="minor" v-for="(item, i) in buttons" :key="i" @click="btnHandle(i)" class="share-button" :class="i===0&&!suffix?'btn-disable':''">
            <i :class="[item.icon, 'share-icon']" v-if="i!==0"></i>
            <i v-else class="define-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="图层_1" x="0px" y="0px" viewBox="0 0 1024 1024" xml:space="preserve" width="18" height="18">
                <title>未标题-1</title>
                <g class="st4">
                  <path class="st5" style="transform: scale(40);transform: translate(-330px, -240px) scale(45);" :style="{fill: i===0&&!suffix?'#ccc':'#85B200'}" d="M18,11v2h2h5v9H12V11H18 M20,9H10v15h17V11h-7V9L20,9z"/>
                </g>
              </svg>
            </i><span>{{item.name}}</span>
          </w-button>
        </template>
        <template v-else>
          <w-button type="minor" v-for="(item, i) in buttons" :key="i" @click="btnHandle(i)" class="share-button" :class="(i===0&&!suffix)||i===2||i===3?'btn-disable':''">
            <i :class="[item.icon, 'share-icon']" v-if="i!==0"></i>
            <i v-else class="define-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="图层_1" x="0px" y="0px" viewBox="0 0 1024 1024" xml:space="preserve" width="18" height="18">
                <title>未标题-1</title>
                <g class="st4">
                  <path class="st5" style="transform: scale(40);transform: translate(-330px, -240px) scale(45);" :style="{fill: i===0&&!suffix?'#ccc':'#85B200'}" d="M18,11v2h2h5v9H12V11H18 M20,9H10v15h17V11h-7V9L20,9z"/>
                </g>
              </svg>
            </i><span>{{item.name}}</span>
          </w-button>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from '@/assets/utils/CommonUtil'
import {capitalize} from '@/assets/utils'
import MessageService from '@/assets/service/message'
import shareFileActionsMixin from '@/assets/mixins/share-file-actions'
// let urlDomain = window.location.origin;
export default {
  name: 'Share',
  data (){
    return {
      buttons: [
        {icon: 'w-icon-bendiwenjian', name: '打开文件'},
        {icon: 'w-icon-xiazai', name: '下载'},
        {icon: 'r2-icon-action_delete_outline', name: '删除'},
        {icon: 'w-icon-fuzhidaoqiyekongjian', name: '转存到我的空间'}
      ],
      state: 0, // 0 正常；1  已删除； 2  连接失效
      user: {userType: 3},
      shareItem: {
        shareToken: this.$route.query.shareToken,
        jsonToken: this.$route.query.jsonToken,
        fileId: this.$route.query.fileId,
        fileType: this.$route.query.fileType,
        fileName: this.$route.query.fileName,
        shareId: this.$route.query.shareId,
        remainTime: null
      },
      encrypt: 0
    }
  },
  mixins: [shareFileActionsMixin],
  computed: {
    fileName () {
      let fileName = ''
      fileName = this.$route.query.fileName
      return fileName
    },
    suffix () {
      // 计价工程、结算工程、验工工程、审核工程、概算工程
      // const reg = /\.(gbq5|gbq6|gtj)$/i;
      const reg = /\.(gbq5|gbq6|gbq6jy|gbq6xs)$/i
      const arr = reg.exec(this.fileName)
      if (+this.encrypt === 1){
        return false
      }
      if (arr && arr.length > 1) {
        return capitalize(arr[1], true, true)
      } else {
        return false
      }
    }
  },
  methods: {
    // 返回
    goBack (){
      this.$router.push({ path: '/home' })
    },
    // 按钮点击
    btnHandle (index) {
      switch (index){
        case 0:
          if (this.suffix){
            this.shareFileActionEmitter('preview', this.shareItem)
          }
          break
        case 1:
          this.shareFileActionEmitter('download', this.shareItem)
          break
        case 2:
          this.$confirm({
            message: '确定删除',
            tips: '确定要把通知删除？',
            tipsRed: '删除将无法找回！',
            submit: () => {
              this.shareFileActionEmitter('delete', this.shareItem).then(res => {
                if (+res.code === 200 && res.data === true){
                  this.$message.success('删除成功')
                  this.state = 1
                } else {
                  this.$message.error('删除失败')
                }
              }).catch((e) => {
                this.$message.error('删除失败')
              })
            },
            submitText: '确定'
          })
          break
        case 3:
          this.shareFileActionEmitter('unloading', this.shareItem).then(res => {
            if (+res.code === 200){
              this.$confirm({
                message: '保存成功',
                noCancelBtn: true,
                submit: () => {
                  this.state = 2
                },
                submitText: '确定'
              })
            } else {
              this.$message.error(res.message ? res.message : '保存失败')
            }
          }).catch((e) => { this.$message.error('保存失败') })
          break
        default:
          break
      }
    },
    // 关联分享消息和用户
    readMessage (){
      MessageService.getShareMessagesReadBack({share_id: this.$route.query.shareId}).then((res) => {
        // 是否删除  是否失效
        if (+res.code === 240002){ // 连接失效
          this.state = 2
        } else if (+res.code === 240007){ // 文件被删
          this.state = 1
        }
      })
    },
    // 获取消息是否失效、是否删除、是否加密
    getMessageState (){
      MessageService.getShareMessagesState({shareId: this.$route.query.shareId}).then((res) => {
        // 是否删除  是否失效
        if (+res.code === 200 && res.data){
          if (res.data.isExpire){ // 连接失效
            this.state = 2
          }
          if (res.data.isDelete){ // 删除
            this.state = 1
          }
          if (res.data.isEncrypt){ // 文件加密
            this.encrypt = 1
          }
          if (res.data.isTransfer){ // 文件加密
            this.state = 2
          }
        }
      })
    }
  },
  created () {},
  mounted () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    // 文件状态查询
    this.getMessageState()
    // 文件接收
    this.readMessage()
  },
  components: {

  }
}
</script>
<style lang="less" type="text/less">
.share-main{
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .share-box{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .share-title{
    line-height: 80px;
    font-size:20px;
    color:rgba(0,0,0,1);
  }
  .share-button{
    margin: 0 15px;
    &:hover{
      background-color: #fbfbfb;
      background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f3f3f3));
      background: linear-gradient(top, #fff, #f3f3f3);
    }
    &.btn-disable{
      cursor: not-allowed;
      color: #888;
      &:hover{
        background-color: #fff;
      }
      .share-icon{
        color: #ccc;
      }
    }
  }
  .back-button{
    position: absolute;
    left: 0;
    top: 44px;
    margin-top: 40px;
    margin-left: 48px;
    svg{
      width: 14px;
      font-style: normal;
      vertical-align: middle;
      display: inline-block;
      margin-top: -3px;
    }
  }
  .share-icon{
    color: #85B200;
  }
  .disable-icon{
    color: #ccc;
  }
  .define-icon{
    font-size: 18px;
    font-style: normal;
    vertical-align: middle;
    display: inline-block;
  }
}
</style>
